import React, { useState, useEffect } from 'react'
import { Box, Paper, Text, Grid, Group, ThemeIcon } from '@mantine/core'
import { PieChart } from '@mantine/charts'
import { IconPointFilled } from '@tabler/icons-react'

const DashboardStatsRole = ({ statsRole }) => {
  const [dataRole, setDataRole] = useState([])

  const getRandomColor = () => {
    const letter = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letter[Math.floor(Math.random() * 16)]
    }
    return color
  }

  useEffect(() => {
    if (statsRole) {
      handleRemapRoleStats(statsRole)
    }
    // eslint-disable-next-line
  }, [statsRole])

  const handleRemapRoleStats = (data) => {
    const remap = data.map((val) => {
      return {
        ...val,
        value: val.count,
        color: getRandomColor()
      }
    })
    setDataRole(remap)
  }

  const mappingDataRole = (data) => {
      if (data.length > 0) {
        const remap = data.map((val, index) => {
          return (
            <Group gap={2}>
              <ThemeIcon variant="white" size='lg' color={val.color}>
                <IconPointFilled style={{ width: '70%', height: '70%' }} />
              </ThemeIcon>
              <Text fz={12} fw='500'>{val.name}</Text>
            </Group>
          )
        })
        return remap
      }
    }

  return (
    <Paper shadow="sm" p='md' withBorder radius='md'>
      <Text fz='md' fw='bold' mb='md'>Total users based on Role</Text>
      <Box my={20}>
        <Grid align='flex-start'>
          <Grid.Col span={{ base: 12, md: 5, lg: 5 }}>
            <Box>
              {mappingDataRole(dataRole)}
            </Box>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 7, lg: 7 }}>
            <PieChart
              size={260}
              data={dataRole}
              labelPosition='outside'
              labelsType='percent'
              withLabels
              withTooltip tooltipDataSource="segment"
            />
          </Grid.Col>
        </Grid>
      </Box>
    </Paper>
  )
}

export default DashboardStatsRole